import { jsx } from "react/jsx-runtime";
import { Box } from "../../Box/Box.mjs";
import { useIcon } from "../../../hooks/useIcon/index.mjs";
import { IconEditSvg } from "./IconEditSvg.mjs";
const IconEdit = (props) => {
  const iconProps = useIcon(props);
  return /* @__PURE__ */ jsx(Box, { component: IconEditSvg, ...iconProps });
};
export {
  IconEdit
};
